import styled from 'styled-components';
import { AppCard, AppCheckbox } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../components/helpers/Translator';
import colors from '../../../../../constants/colors';

export default function ModuleComsaEnvironmentalIndustrialUseNormalAspectsCard(
  props
) {
  const {
    index,
    filterApplicable,
    values,
    motive,
    subphase,
    setFieldValue,
  } = props;

  if (filterApplicable && !values?.[index]?.applicable) return null;

  return (
    <Container className="mb-2" bodyClassName="p-1">
      <AppCheckbox
        title={
          values?.[index]?.applicable
            ? ReactDOMServer.renderToString(
                <Translator
                  file="module-comsaEnvironmental"
                  name="no.applicable"
                />
              )
            : ReactDOMServer.renderToString(
                <Translator
                  file="module-comsaEnvironmental"
                  name="assign.as.applicable"
                />
              )
        }
        value={values?.[index]?.applicable}
        className="d-inline-flex"
        onChange={(v) => setFieldValue(`[${index}].applicable`, v)}
      />
      <AppCardContainer
        className="mb-2"
        bodyClassName="p-1"
        $applicable={values?.[index]?.applicable}
      >
        <div className="info-block">
          <div className="line mb-2">
            <div>
              <Translator file="module-comsaEnvironmental" name="sub-phase" />:
            </div>
            <div className="mb-2">
              <b>
                <Translator file="module-comsaEnvironmental" name={subphase} />
              </b>
            </div>
          </div>
          <div className="line mb-2">
            <div>
              <Translator file="module-comsaEnvironmental" name="reason" />:
            </div>
            <div>
              <b>
                <Translator file="module-comsaEnvironmental" name={motive} />
              </b>
            </div>
          </div>
        </div>
      </AppCardContainer>
    </Container>
  );
}

const Container = styled.div`
  display: grid;
  grid-template-columns: 24px 1fr;
`;

const AppCardContainer = styled(AppCard)`
  border: 2px solid ${(props) => (props.$applicable ? '#28a745' : '#fff')};
  .info-block {
    display: flex;
    flex-direction: column;
    @media (min-width: 768px) {
      flex-direction: row;
    }
    .line {
      flex: 1 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      color: ${colors.primaryLight};
      &.no-center {
        text-align: left;
      }
    }
  }
`;
